import { createFileRoute } from "@tanstack/react-router";
import AdminCategoriesPage from "@/admin/pages/categories";

export const Route = createFileRoute("/admin/categories/")({
  component: AdminCategoriesPage,
});
